import { useDispatch } from "react-redux";
import { CardItemCliente } from "./CardItemCliente";
import { useEffect } from "react";
import { AgregarProdImporte } from "../features/ui/uiSlice";
import { DataField } from "./DataField";
import { Info, User } from "lucide-react";

export const CardCliente = ({ informacion }) => {
  let info = informacion;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      AgregarProdImporte({
        fi_producto: info.Producto,
        SA_Importe: info.SA_Importe,
        Promass: info.Promass,
        E_mail_Aseg: info.E_mail_Aseg,
        Asegurado: info.Asegurado,
        ApellidoP_Aseg: info.ApellidoP_Aseg,
        ApellidoM_Aseg: info.ApellidoM_Aseg,
        RFC: info.RFC,
        Fecha_Nac: info.Fecha_Nac,
        Tel_Cas_Aseg: info.Tel_Cas_Aseg,
        Tel_Cel_Aseg: info.Tel_Cel_Aseg,
        Calle_Aseg: info.Calle_Aseg,
        Num_Ext_Aseg: info.Num_Ext_Aseg,
        Num_Int_Aseg: info.Num_Int_Aseg,
        Estado_Aseg: info.Estado_Aseg,
        Colonia_Aseg: info.Colonia_Aseg,
        Delegacion_Aseg: info.Delegacion_Aseg,
        Ciudad_Aseg: info.Ciudad_Aseg,
        Canal: info.Canal,
      })
    );
  }, []);

  return (
    <div className="mx-auto mt-5 w-full max-w-6xl overflow-hidden rounded-[32px] border border-slate-100 bg-white shadow-xl shadow-blue-900/5">
      <div
        className={
          info.IDStatus === 2
            ? "mx-5 mt-5 flex items-center gap-2 rounded-full border border-red-700 bg-red-700 p-2 px-5 py-2 text-white"
            : "mx-5 mt-5 flex items-center gap-2 rounded-full border border-emerald-100 bg-emerald-50 p-2 px-5 py-2 text-emerald-700"
        }
      >
        <span
          className={
            info.IDStatus === 2
              ? "h-2 w-2 animate-pulse rounded-full bg-red-700"
              : "h-2 w-2 animate-pulse rounded-full bg-emerald-500"
          }
        ></span>
        <span className="text-[11px] font-black uppercase tracking-wider">
          ESTATUS: {info.IDStatus === 2 ? "Cancelada" : "Activa"}
        </span>
      </div>
      <div className="p-10">
        <div className="mb-10 flex items-start justify-between">
          <div>
            <h2 className="font-manrope text-4xl font-black tracking-tight text-slate-900">
              Información del Cliente
            </h2>
            <p className="mt-2 font-medium text-slate-500">
              Gestión de expediente y detalles de póliza
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-x-12 gap-y-8 lg:grid-cols-1">
          <DataField
            label="Contratante"
            value={info.contratante_nombre}
            icon={User}
          />
          <DataField
            label="Asegurado"
            value={info.asegurado_nombre}
            icon={User}
          />
          <DataField label="Nacimiento" value={info.Fecha_Nac} icon={Info} />
          <DataField label="Cuenta" value={info.cuenta} icon={Info} />
          <DataField
            label="Producto"
            value={info.Producto === "1" ? "Básico" : "Amplio"}
            icon={Info}
          />
          <DataField label="Prima Total" value={info.Prima_Total} icon={Info} />
          <DataField label="S.A" value={info.SA_Importe} icon={Info} />
          <DataField
            label="Fecha de Compra"
            value={info.Fecha_Compra}
            icon={Info}
          />
          <DataField
            label="Teléfono Particular"
            value={info.Telefono_Cel}
            icon={Info}
          />
          <DataField label="Certificado" value={info.Promass} icon={Info} />
          <DataField
            label="Canal de Contratación"
            value={info.Canal}
            icon={Info}
          />
        </div>
      </div>
    </div>
  );
};
